// 'use client';

import { useNavigate } from "react-router-dom";
import { useUserRole } from "../../utils/helperMethods";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SummaryInfoCards({
  totalAssessments,
  totalProviders,
  totalRFI,
  totalSponsors,
  navVQA,
  navRfi,
}) {
  const navigate = useNavigate();
  const user = useUserRole();
  const data = [
    ...(user === "Backend User" ||
    user === "Backend Master User" ||
    user === "Provider User" ||
    user === "Provider Master User"
      ? [
          {
            name: user === "Provider User" ? "My Sponsors" : "Total Sponsors",
            value: totalSponsors ? totalSponsors : "0",

            changeType: "positive",
            href: "/",
            show: false,
          },
        ]
      : []),
    ...(user === "Backend User" ||
    user === "Backend Master User" ||
    user === "Sponsor User" ||
    user === "Sponsor Master User"
      ? [
          {
            name: "Total Vendors",
            value: totalProviders ? totalProviders : "",

            changeType: "positive",
            href: user === "Sponsor User" ? "/Providers" : "/",
            show: user === "Sponsor User" ? true : false,
          },
        ]
      : []),
    {
      name: user === "Provider User" ? "My Diligent VQQs" : "Total VQQs",
      value: totalRFI,
      changeType: "positive",
      href: navRfi,
      show: true,
    },
    {
      name: user === "Provider User" ? "My VQAs" : "Total VQAs",
      value: totalAssessments ? totalAssessments : "0",
      changeType: "negative",
      href: navVQA,
      show: true,
    },
  ];
  return (
    <>
      <dl className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {data.map((item) => (
          <div
            key={item.name}
            className="p-0 border border-gray-300 rounded-md text-sm text-gray-600"
          >
            <div className="px-4 py-4">
              <dd className="flex items-start justify-between space-x-2">
                <span className="truncate text-tremor-default text-tremor-content dark:text-dark-tremor-content">
                  {item.name}
                </span>
                {/* <span
                  className={classNames(
                    item.changeType === "positive"
                      ? "text-emerald-700 dark:text-emerald-500"
                      : "text-red-700 dark:text-red-500",
                    "text-tremor-default font-medium"
                  )}
                >
                  {item.change}
                </span> */}
              </dd>
              <dd className="mt-1 text-2xl font-semibold">{item.value}</dd>
            </div>
            <div className="flex justify-end border-t border-tremor-border px-4 py-3 dark:border-dark-tremor-border bg-slate-50">
              <span
                onClick={() => {
                  navigate(item.href);
                }}
                className={`text-sm font-semibold text-blue-600 ${
                  item?.show
                    ? "cursor-pointer hover:text-blue-800"
                    : "cursor-default"
                } dark:text-blue-400 dark:hover:text-blue-600`}
              >
                {item?.show ? <span>View more</span> : ""}{" "}
                {item.show ? (
                  <span>&#8594;</span>
                ) : (
                  <span className="opacity-0">s</span>
                )}
              </span>
            </div>
          </div>
        ))}
      </dl>
    </>
  );
}
